export default __webpack_public_path__ + "static/media/re.ea969fea.png";